import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_SALDO_EDIT: MijnRoute = {
    path: 'saldo-notificatie/:id',
    navigationEvent: 'toSaldoNotificatie',
    regex: /^\/zelf-regelen\/notificaties-beheren\/saldo-notificatie\/[^/]+$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/saldo-notificatie'
};
